import createRoute from '@widesk-ui/tools/createRoute';
import OrderModel  from '@models/shop/OrderModel';

export default createRoute.splitView(
	'/entertainments/:entertainmentId/orders-to-process',
	'shop',
	'OrderToProcessSplitView',
	OrderModel.localize('plural') + ' à traiter'
);
